import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/languages/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/languages`, config),
    fetchDefault: (config: AxiosRequestConfig) =>
        api.get(`/languages/defaults`, config),
    fetchAll: (config: AxiosRequestConfig) => api.get(`/languages/all`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/languages/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/languages`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/languages/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/languages/${url.id}`, data, config),
};

export default requests;
